"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateClientPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var entry_1 = require("../../../../reducers/slices/entry");
var react_redux_1 = require("react-redux");
var react_1 = require("react");
var client_details_1 = require("./tabs/client_details");
var company_details_1 = require("./tabs/company_details");
var company_information_1 = require("./tabs/company_information");
var horizontalStepsComponent_1 = __importDefault(require("../../../../components/horizontalStepsComponent"));
var payment_plan_1 = require("./tabs/payment_plan");
var CreateClientPage = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var entryTheme = (0, react_redux_1.useSelector)(function (state) { return state.entryState; }).entryTheme;
    var currentStep = (0, react_redux_1.useSelector)(function (state) { return state.entryState; }).currentStep;
    var onStepChange = function (step) {
        dispatch((0, entry_1.setCurrentStep)(step));
    };
    (0, react_1.useEffect)(function () {
        // offering_list().then((response) => {
        //   dispatch(setOfferings(response.content[0]));
        // });
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", { className: "w-full flex flex-col h-full justify-center overflow-y-auto ", children: (0, jsx_runtime_1.jsx)("div", { className: "overflow-y-auto overflow-x-hidden  px-8", children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-6 w-full", children: [(0, jsx_runtime_1.jsx)(horizontalStepsComponent_1.default, { currentStep: currentStep, onStepChange: onStepChange, steps: [
                            { title: "Test Stripe" },
                            { title: "Create Account" },
                            { title: "Company Details" },
                            { title: "Company Information" },
                            { title: "Payment Plan" },
                        ] }), currentStep === 0 && (0, jsx_runtime_1.jsx)(payment_plan_1.PaymentPlanPage, {}), currentStep === 1 && (0, jsx_runtime_1.jsx)(client_details_1.ClientDetailsPage, {}), currentStep === 2 && (0, jsx_runtime_1.jsx)(company_details_1.CompanyDetailsPage, {}), currentStep === 3 && (0, jsx_runtime_1.jsx)(company_information_1.CompanyInformationPage, {}), currentStep === 4 && (0, jsx_runtime_1.jsx)(payment_plan_1.PaymentPlanPage, {})] }) }) }));
};
exports.CreateClientPage = CreateClientPage;
